angular.module('ufcw')

.constant('EnvConfig', {
  "URL_API"			: "https://api-agenda.lifezonamerica.uy/",
  "URL_PAGOS"			: "https://payment.lifezonamerica.uy/",
  "URL_PAGOSCANCHA"	: "https://paymentv2.lifezonamerica.uy/",
  "URL_IMAGES"  : "https://squalus-public-production.s3.us-east-2.amazonaws.com/agenda/lifezonamerica/",
  "URL_FILES"  : "https://squalus-public-production.s3.us-east-2.amazonaws.com/agenda/lifezonamerica/",
  "COMPANY_ID"  : "1",
  "SIGNIN_ENABLED":true,
  "RESERVATION_ENABLED":false,
  "footer_app_name":"LIFE Zonamerica",
  "footer_email":"redes@lifezonamerica.uy",
  "footer_facebook":"https://www.facebook.com/lifezonamerica/",
  "footer_twitter":"",
  "footer_instagram":"https://www.instagram.com/lifezonamerica/",
  "footer_youtube":"",
  "show_aviso_covid":false,
  "show_cuponeras":false,
  "show_reglas":false,
  "signup_nrosocio":false,
  "signup_dob":false,
  "projectname":"lifezonamerica",
  "show_payment_expiration": false,
  "show_carnet_expiration": false,
  "useDefaultStyle":false,
  "show_canchas":true,
  "show_chat":true
});
